import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {parseArchivedParam} from '@github-ui/repository-label/utils/archived-param'
import {RepositoryLabelIndexPageQuery} from '@github-ui/server-persisted-queries'
import type {RepositoryLabelIndexPageQueryQuery} from '@github-ui/server-persisted-queries/types/RepositoryLabelIndexPageQuery'
import {issuesAppBuilder} from '../config/app-builder'

// need this type to expose the errors array so we can detect FORBIDDEN
export type LabelsPayload = RepositoryDataResponse<RepositoryLabelIndexPageQueryQuery>

export function buildLabelsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('labelsRoute', {
    path: '/:owner/:repo/labels',
    queries: [
      mainQuery<LabelsPayload>({
        queryDeps: ({pathname, searchParams}) => {
          const archivedParam = searchParams.get('archived')
          const archiveType = isFeatureEnabled('labels_archiving') ? parseArchivedParam(archivedParam) : undefined

          return {
            pathname,
            searchParams: {
              queryId: RepositoryLabelIndexPageQuery,
              page: searchParams.get('page') || '1',
              sort: searchParams.get('sort') || 'name-asc',
              ...(searchParams.get('q') ? {q: searchParams.get('q') || ''} : {}),
              ...(archiveType !== undefined ? {archiveType} : {}),
            },
          }
        },
      }),
    ],
  })
}

export const labelsRoute = buildLabelsRoute(issuesAppBuilder)
